import { Alert, Typography } from '@one-thd/sui-atomic-components';
import React from 'react';
import { ChallengesContext } from '../../../../contexts';
import { rhDrawer } from '../../../../constants/RewardsHub';
export var ChallengeError = function () {
    var getChallengesInfo = React.useContext(ChallengesContext).getChallengesInfo;
    return (React.createElement("div", { className: "sui-pb-5" },
        React.createElement(Alert, { status: "error" },
            React.createElement("div", null,
                React.createElement(Typography, null, rhDrawer.challengeErrorMessage),
                React.createElement("div", { className: "sui-text-base" },
                    React.createElement("button", { type: "button", onClick: function () {
                            getChallengesInfo();
                        } },
                        React.createElement("u", null, "Refresh")))))));
};
